import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FAN_NAME_MAX } from './chatPrefs'

interface Props {
  official: string
  handle: string
  current: string
  /** Resolves once saved; a rejection keeps the dialog open with the message. */
  onSave: (name: string) => Promise<void>
  onClose: () => void
}

/** The OnlyFans-style rename overlay (fan-rename.js): the official name above, the person's name below. */
export function RenameDialog({ official, handle, current, onSave, onClose }: Props) {
  const { t } = useTranslation('chats')
  const [value, setValue] = useState(current)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const canSave = !busy && value !== current && (value.trim().length > 0 || Boolean(current))
  const save = async () => {
    if (!canSave) return
    setBusy(true)
    setError(null)
    try {
      await onSave(value.trim().slice(0, FAN_NAME_MAX))
      onClose()
    } catch (err) {
      setError((err as Error).message)
      setBusy(false)
    }
  }
  return (
    <div className="cp-modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
      <div className="cp-modal" role="dialog" aria-modal="true" aria-label={t('rename.title')}>
        <div className="cp-modal-title">{t('rename.title')}</div>
        <div className="cp-rename-official">
          <b>{official}</b>
          <span>{handle}</span>
        </div>
        <label className="cp-rename-field">
          <input
            autoFocus
            value={value}
            maxLength={FAN_NAME_MAX}
            placeholder={t('rename.placeholder')}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Escape') onClose()
              if (e.key === 'Enter') void save()
            }}
          />
          <span className="cp-rename-count">
            {value.length}/{FAN_NAME_MAX}
          </span>
        </label>
        {error && <div className="cp-modal-error">{error}</div>}
        <div className="cp-modal-actions">
          <button type="button" className="cp-btn" onClick={onClose}>
            {t('common.cancel')}
          </button>
          <button type="button" className="cp-btn cp-btn--primary" disabled={!canSave} onClick={() => void save()}>
            {t('common.save')}
          </button>
        </div>
      </div>
    </div>
  )
}
